module.exports = __webpack_public_path__ + "media/images/black_history_month/map-d02791313d87eb68adbfb852b8b6067f.svg";